import c from "../common"

export default {
    ModifyList: c.ModifyPartnersList.chn,
    Partner: "夥伴",
}